export default __webpack_public_path__ + "static/media/4.53cdfdd7.jpg";